import { render } from "./NewBlogView.vue?vue&type=template&id=2261bd21&scoped=true"
import script from "./NewBlogView.vue?vue&type=script&lang=js"
export * from "./NewBlogView.vue?vue&type=script&lang=js"

import "./NewBlogView.vue?vue&type=style&index=0&id=2261bd21&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2261bd21"]])

export default __exports__